// Data seam: sphinx REST (/api/sphinx) — see lib/sphinx-api.ts.
//
// `DataClient` used to be the ConvexReactClient handle that imperative
// (non-hook) callers passed to the `fetch*` helpers exported by the domain
// modules. Those helpers now call the REST API directly; the handle is kept as
// an opaque token so call sites (`fetchProjectServers(client, …)`) did not
// have to change.
export type DataClient = { readonly kind: "sphinx" };

const SPHINX_CLIENT: DataClient = { kind: "sphinx" };

export function useDataClient(): DataClient {
  return SPHINX_CLIENT;
}
